import { SyntheticEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import Tab from "@mui/material/Tab";

import { InfoIcon, TaskGropsIcon } from "@dotnet/telematics-design-system";

import SegmentedToggle, {
    TAB_SIZES
} from "components/DesignComponents/SegmentedToggle";
import { useMediaQueries } from "shared";

import General from "./General";
import Header from "./Header";
import Permissions from "./Permissions";

const UserDetails = () => {
    const { t } = useTranslation();
    const { toMd } = useMediaQueries();

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (_: SyntheticEvent, newValue: number) =>
        setTabValue(newValue);

    return (
        <>
            <Header />

            <div>
                <SegmentedToggle
                    value={tabValue}
                    size={TAB_SIZES.Small}
                    tabWidth={toMd ? "258px" : "377px"}
                    onChange={handleTabChange}
                >
                    <Tab
                        label={t("Table details##user details")}
                        icon={<InfoIcon />}
                    />

                    <Tab
                        label={t("Table details##permissions info")}
                        icon={<TaskGropsIcon />}
                    />
                </SegmentedToggle>
            </div>

            {tabValue === 0 && <General />}
            {tabValue === 1 && <Permissions />}
        </>
    );
};

export default UserDetails;
